export default {"src":"/_next/static/media/umbrella.85cc2b6a.svg","height":13,"width":16};